













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class KakuteiMsgComponent extends Vue {
  @Prop() msg!: number;
  readonly w = 792;
  readonly h = 66;
  textLength: string | null = null;
  mounted(): void {
    this.resizeFont();
  }
  @Watch("msg")
  changeMsg(): void {
    this.textLength = null;
    this.$nextTick(this.resizeFont);
  }
  resizeFont(): void {
    const txt = this.$refs.txt as SVGTextElement;
    if (this.w - 10 < txt.getBBox().width) {
      this.textLength = `${this.w - 10}`;
    }
  }
}
